import React from 'react';
import { Box, CardContent, Typography } from '@material-ui/core';
import { PremiumInfoQuery } from '../../../../schema';
import { useStyles } from '../useStyles';

type Props = {
  data: PremiumInfoQuery | undefined;
};

export const MechanicsCard = ({ data }: Props) => {
  const classes = useStyles();
  const mechanicsText = data?.premiumInfo?.mechanicsText;

  return (
    <CardContent>
      <Box className={classes.mechanicsText}>
        <Typography variant="body1">{mechanicsText || 'Текст механики не задан'}</Typography>
      </Box>
    </CardContent>
  );
};
